import React from 'react'
import { useNavigate } from 'react-router-dom'
import { CDN_HOST } from '../../common/cdn-host'
import styles from './404.module.scss'
import Button from '../../components/core/Button'
import { goToBrandLogin } from '../../common/brand-login'
const HeroMain = `${CDN_HOST}/login_hero.webp`

const NotFoundContainer = () => {
  const navigate = useNavigate()

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <img src={HeroMain} alt='FinalBit' />
        <div
          className={styles.introSection}
        >
          <div className={styles.textContent}>
            <h1>404: Page Not Found</h1>
          </div>

          <div className={styles.content}>
            <div className={styles.buttonContainer}>
              <Button
                size='small'
                color='primary'
                mode='contained'
                onClick={() => navigate('/')}
              >To Home Page
              </Button>
              <Button
                size='small'
                color='primary'
                mode='contained'
                onClick={() => goToBrandLogin()}
              >Login
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotFoundContainer
